<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%">
      <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">สร้างใบลดหนี้</v-card-title>
      <v-card-title class="px-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> สร้างใบลดหนี้
      </v-card-title>
      <v-card-text class="pb-0">
        <v-card elevation="0" width="100%" height="100%" style="background: #FFFFFF; border: 1px solid #EBEBEB; border-radius: 8px;">
          <v-form ref="FormCreditNote" :lazy-validation="lazy">
            <!-- ข้อมูลเอกสาร -->
            <v-row no-gutters :class="!MobileSize && !IpadSize && !IpadProSize ?  'mx-6 mt-7': 'mx-5 mt-6'">
              <v-col cols="12">
                <v-row>
                  <v-col :cols="!MobileSize && !IpadSize && !IpadProSize ? 6 : 12" :class="!MobileSize && !IpadSize && !IpadProSize ? '' : 'py-0'">
                    <span><b>เลขที่เอกสาร</b><span style="color: red;">*</span></span>
                    <v-text-field v-model="docNumber" :rules="Rules.doc_number" placeholder="ระบุเลขที่เอกสาร" outlined dense maxLength="12"></v-text-field>
                  </v-col>
                  <v-col :cols="!MobileSize && !IpadSize && !IpadProSize ? 6 : 12" :class="!MobileSize && !IpadSize && !IpadProSize ? '' : 'pt-0'">
                    <span><b>วันที่เอกสาร</b><span style="color: red;">*</span></span>
                    <v-dialog
                      ref="dialogCreatedDate"
                      v-model="modalDocumentDate"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="DocumentDateShow"
                          readonly
                          outlined
                          v-bind="attrs"
                          v-on="on"
                          dense
                          :rules="Rules.documentDateShow"
                          placeholder="ระบุวันที่เอกสาร"
                        ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                      </template>
                      <v-date-picker
                        color="#27AB9C"
                        v-model="DocumentDate"
                        scrollable
                        flat
                        locale="th"
                      >
                        <v-row dense>
                          <v-col cols="12" align="end">
                            <v-btn text color="primary" @click="clearDocumentDate()"> ยกเลิก </v-btn>
                            <v-btn text color="primary" @click="saveDocumentDate(DocumentDate)"> ตกลง</v-btn>
                          </v-col>
                        </v-row>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <span><b>เลขที่เอกสารอ้างอิง</b><span style="color: red;">*</span></span>
                <v-autocomplete
                  v-model="refNameDocEtax"
                  :items="refNameDocEtaxList"
                  outlined dense
                  placeholder="เลือกเอกสารอ้างอิง"
                  no-data-text="ไม่พบเลขที่เอกสารอ้างอิงที่ค้นหา"
                  item-text="ref_name_show"
                  return-object
                  @click="getListEtaxDocumentOrder()"
                  :rules="Rules.refNameDocEtax"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <span><b>หมายเหตุ</b><span style="color: red;">*</span></span>
                <v-textarea rows="3" @keydown="handleKeyDown" v-model="reason" :rules="Rules.reason" small placeholder="หมายเหตุ" outlined dense :counter="100" oninput="this.value = this.value.substring(0, 100)"></v-textarea>
              </v-col>
            </v-row>
            <!-- เพิ่มรายการสินค้าและบริการ desktop iapdPro-->
            <div v-if="!MobileSize && !IpadSize">
              <v-row class="mx-5 my-5" style="background-color: #E6F5F3; color: #27AB9C; border-radius: 6px;">
                <v-col cols="1" class="px-1" style="margin: auto;" align="center">
                  <span>ที่</span>
                </v-col>
                <v-col cols="4" class="px-1">
                  <span>รายการสินค้าและบริการ<span style="color: red;">*</span></span>
                </v-col>
                <v-col cols="2" class="px-1">
                  <span>จำนวน<span style="color: red;">*</span></span>
                </v-col>
                <v-col cols="2" class="px-1">
                  <span>ราคา/หน่วย (รวม VAT)<span style="color: red;">*</span></span>
                </v-col>
                <v-col cols="2" class="px-1">
                  <span>ราคารวม (รวม VAT)<span style="color: red;">*</span></span>
                </v-col>
                <v-col cols="1" class="px-0">
                </v-col>
              </v-row>
              <v-row class="mx-6" v-for="(item, index) in  dataProductList" :key="index">
                <v-col cols="1" class="px-1 mt-1" align="center">
                  <span>{{ index + 1 }}</span>
                </v-col>
                <v-col cols="4" class="px-1 py-1">
                  <v-text-field v-model="item.product_name" maxLength="70" :rules="Rules.product_name" outlined dense></v-text-field>
                </v-col>
                <v-col cols="2" class="px-1 py-1">
                  <v-text-field v-model="item.quantity" @change="changeQuantity(item)" @input="inputTwoDigit(item.quantity)" :rules="Rules.quantity" outlined dense oninput="this.value = this.value.replace(/^[.]/, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^0+(?=\d)/,'').replace(/(\.\d{2}).+/g, '$1')"></v-text-field>
                </v-col>
                <v-col cols="2" class="px-1 py-1">
                  <v-text-field v-model="item.price" @change="changePrice(item)" @input="inputTwoDigit(item.price)" :rules="Rules.price" outlined dense oninput="this.value = this.value.replace(/^[.]/, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^0+(?=\d)/,'').replace(/(\.\d{2}).+/g, '$1')"></v-text-field>
                </v-col>
                <v-col cols="2" class="px-1 py-1">
                  <v-text-field v-model="item.net_price" @change="changeNetPrice(item)" @input="inputTwoDigit(item.net_price)" :rules="Rules.net_price" outlined dense oninput="this.value = this.value.replace(/^[.]/, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^0+(?=\d)/,'').replace(/(\.\d{2}).+/g, '$1')"></v-text-field>
                </v-col>
                <v-col cols="1" class="px-0 py-2 mt-2" v-if="index === 0">
                  <v-btn x-small v-if="lastIndexArr === index" icon color="white" style="width: 25px; height: 25px; background-color: #27AB9C;" @click="addItem()"><v-icon>mdi-plus</v-icon></v-btn>
                </v-col>
                <v-col cols="1" class="px-0 py-2 mt-2" v-else-if="index === lastIndexArr">
                  <v-btn x-small icon class="mr-2" color="#27AB9C" outlined style="width: 25px; height: 25px;" @click="deleteItem(index)"><v-icon>mdi-minus</v-icon></v-btn>
                  <v-btn x-small icon color="white" style="width: 25px; height: 25px; background-color: #27AB9C;" @click="addItem()"><v-icon>mdi-plus</v-icon></v-btn>
                </v-col>
                <v-col cols="1" class="px-0 py-2 mt-2" v-else>
                  <v-btn x-small icon color="#27AB9C" style="width: 25px; height: 25px;" outlined @click="deleteItem(index)"><v-icon>mdi-minus</v-icon></v-btn>
                </v-col>
              </v-row>
            </div>
            <!-- เพิ่มรายการสินค้าและบริการ mobile ipad -->
            <div v-else class="pt-2">
              <v-row class="mx-5 py-2" v-for="(item, index) in dataProductList" :key="index">
                <v-card elevation="0" width="100%" height="100%" style="background: #FFFFFF; border: 1px solid #EBEBEB; border-radius: 8px;">
                  <v-col cols="6" align="start">
                    <span>ที่ {{ index + 1 }}</span>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <span>รายการสินค้าและบริการ<span style="color: red;">*</span></span>
                    <v-text-field v-model="item.product_name" maxLength="70" :rules="Rules.product_name" outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <span>จำนวน<span style="color: red;">*</span></span>
                    <v-text-field v-model="item.quantity" @change="changeQuantity(item)" @input="inputTwoDigit(item.quantity)" :rules="Rules.quantity" outlined dense oninput="this.value = this.value.replace(/^[.]/, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^0+(?=\d)/,'').replace(/(\.\d{2}).+/g, '$1')"></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <span>ราคา/หน่วย (รวม VAT)<span style="color: red;">*</span></span>
                    <v-text-field v-model="item.price" @change="changePrice(item)" @input="inputTwoDigit(item.price)" :rules="Rules.price" outlined dense oninput="this.value = this.value.replace(/^[.]/, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^0+(?=\d)/,'').replace(/(\.\d{2}).+/g, '$1')"></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <span>ราคารวม (รวม VAT)<span style="color: red;">*</span></span>
                    <v-text-field v-model="item.net_price" @change="changeNetPrice(item)" @input="inputTwoDigit(item.net_price)" :rules="Rules.net_price" outlined dense oninput="this.value = this.value.replace(/^[.]/, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^0+(?=\d)/,'').replace(/(\.\d{2}).+/g, '$1')"></v-text-field>
                  </v-col>
                  <v-col cols="12" align="end" v-if="index === 0">
                    <v-btn x-small v-if="lastIndexArr === index" icon color="white" style="width: 25px; height: 25px; background-color: #27AB9C;" @click="addItem()"><v-icon>mdi-plus</v-icon></v-btn>
                  </v-col>
                  <v-col cols="12" align="end" v-else-if="index === lastIndexArr">
                    <v-btn x-small icon class="mr-2"  color="#27AB9C" style="width: 25px; height: 25px;" outlined @click="deleteItem(index)"><v-icon>mdi-minus</v-icon></v-btn>
                    <v-btn x-small icon color="white" style="width: 25px; height: 25px; background-color: #27AB9C;" @click="addItem()"><v-icon>mdi-plus</v-icon></v-btn>
                  </v-col>
                  <v-col cols="12" align="end" v-else>
                    <v-btn x-small icon color="#27AB9C" style="width: 25px; height: 25px;" outlined @click="deleteItem(index)"><v-icon>mdi-minus</v-icon></v-btn>
                  </v-col>
                  <!-- <v-col cols="1" class="py-2 mt-1" v-if="index === 0">
                    <v-btn small v-if="lastIndexArr === index" icon color="white" style="background-color: #27AB9C;" @click="addItem()"><v-icon>mdi-plus</v-icon></v-btn>
                  </v-col>
                  <v-col cols="1" class="py-2 mt-1" v-else-if="index === lastIndexArr">
                    <v-btn small icon color="white" style="background-color: #27AB9C;" @click="addItem()"><v-icon>mdi-plus</v-icon></v-btn>
                    <v-btn small icon color="#27AB9C" outlined @click="deleteItem(index)"><v-icon>mdi-minus</v-icon></v-btn>
                  </v-col>
                  <v-col cols="1" class="py-2 mt-1" v-else>
                    <v-btn small icon color="#27AB9C" outlined @click="deleteItem(index)"><v-icon>mdi-minus</v-icon></v-btn>
                  </v-col> -->
                </v-card>
              </v-row>
            </div>
            <!-- มูลค่าและผลต่าง desktop iapdPro-->
            <v-row v-if="!MobileSize && !IpadSize" class="mx-6 mt-5 mb-2" align="end" justify="end">
              <v-col cols="12" align="end">
                <span :class="MobileSize ? '' : 'd-inline-block'"><b>มูลค่าตามใบกำกับภาษีเดิม (ก่อน VAT)</b><span style="color: red;">*</span>
                  <v-text-field v-model="originalPrice" :rules="Rules.originalPrice" @change="changeOriginalPrice()" @input="inputTwoDigit(originalPrice)" class=" pl-1 pr-2 d-inline-block" placeholder="ระบุมูลค่าตามใบกำกับภาษีเดิม" outlined dense style="width: 250px;" oninput="this.value = this.value.replace(/^[.]/, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^0+(?=\d)/,'').replace(/(\.\d{2}).+/g, '$1')"></v-text-field>
                  <b>บาท</b></span>
              </v-col>
              <v-col cols="12" align="end">
                <span :class="MobileSize ? '' : 'd-inline-block'"><b>มูลค่าที่ถูกต้อง (ก่อน VAT)</b><span style="color: red;">*</span>
                  <v-text-field v-model="newPrice" :rules="Rules.newPrice" @change="changeTrueValue()" @input="inputTwoDigit(newPrice)" class=" pl-1 pr-2 d-inline-block" placeholder="ระบุมูลค่าที่ถูกต้อง" outlined dense style="width: 250px;" oninput="this.value = this.value.replace(/^[.]/, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^0+(?=\d)/,'').replace(/(\.\d{2}).+/g, '$1')"></v-text-field>
                  <b>บาท</b></span>
              </v-col>
              <v-col cols="12" align="end">
                <span :class="MobileSize ? '' : 'd-inline-block'"><b>ผลต่าง (ก่อน VAT)</b><span style="color: red;">*</span>
                  <v-text-field v-model="differencePrice" :rules="Rules.differencePrice" @change="changeDifference()" @input="inputTwoDigit(differencePrice)" class=" pl-1 pr-2 d-inline-block" placeholder="ระบุผลต่าง" outlined dense style="width: 250px;" oninput="this.value = this.value.replace(/^[.]/, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^0+(?=\d)/,'').replace(/(\.\d{2}).+/g, '$1')"></v-text-field>
                  <b>บาท</b>
                </span>
              </v-col>
            </v-row>
            <!-- มูลค่าและผลต่าง mobile ipad-->
            <v-row v-else class="mx-5 mt-9 mb-3">
              <v-col cols="12" class="py-0">
                <v-row>
                  <v-col cols="12" class="py-0"><span><b>มูลค่าตามใบกำกับภาษีเดิม (ก่อน VAT)</b><span style="color: red;">*</span></span></v-col>
                  <v-col cols="10" class="pt-0">
                    <v-text-field v-model="originalPrice" :rules="Rules.originalPrice" @change="changeOriginalPrice()" @input="inputTwoDigit(originalPrice)" placeholder="ระบุมูลค่าตามใบกำกับภาษีเดิม" outlined dense oninput="this.value = this.value.replace(/^[.]/, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^0+(?=\d)/,'').replace(/(\.\d{2}).+/g, '$1')"></v-text-field>
                  </v-col>
                  <v-col cols="2" :class="MobileSize ? 'px-0 pt-2' : 'pt-2'">
                    <b>บาท</b>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-row>
                  <v-col cols="12" class="pb-0"><span><b>มูลค่าที่ถูกต้อง (ก่อน VAT)</b><span style="color: red;">*</span></span></v-col>
                  <v-col cols="10" class="pt-0">
                    <v-text-field v-model="newPrice" :rules="Rules.newPrice" @change="changeTrueValue()" @input="inputTwoDigit(newPrice)" placeholder="ระบุมูลค่าที่ถูกต้อง" outlined dense oninput="this.value = this.value.replace(/^[.]/, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^0+(?=\d)/,'').replace(/(\.\d{2}).+/g, '$1')"></v-text-field>
                  </v-col>
                  <v-col cols="2" :class="MobileSize ? 'px-0 pt-2' : 'pt-2'">
                    <b>บาท</b>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-row>
                  <v-col cols="12" class="pb-0"><span><b>ผลต่าง (ก่อน VAT)</b><span style="color: red;">*</span></span></v-col>
                  <v-col cols="10" class="pt-0">
                    <v-text-field v-model="differencePrice" :rules="Rules.differencePrice" @change="changeDifference()" @input="inputTwoDigit(differencePrice)" placeholder="ระบุผลต่าง" outlined dense oninput="this.value = this.value.replace(/^[.]/, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^0+(?=\d)/,'').replace(/(\.\d{2}).+/g, '$1')"></v-text-field>
                  </v-col>
                  <v-col cols="2" :class="MobileSize ? 'px-0 pt-2' : 'pt-2'">
                    <b>บาท</b>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-card-text>
      <v-card-actions align="end">
        <v-container>
          <v-spacer></v-spacer>
          <v-btn dense dark outlined color="#27AB9C" class="pl-7 pr-7 mt-2" @click="closeConfirmCreateCreditNote()">ย้อนกลับ</v-btn>
          <v-btn dense color="#27AB9C" class="ml-4 mt-2 pl-8 pr-8 white--text" @click="createCreditNote()">สร้างใบลดหนี้</v-btn>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { Decode, Encode } from '@/services'
import moment from 'moment'
export default {
  components: {
  },
  data () {
    return {
      shop: '',
      lazy: false,
      userDetailSelling: '',
      customerData: '',
      docNumber: '',
      modalDocumentDate: false,
      DocumentDate: '',
      DocumentDateShow: '',
      DocumentDateSave: '',
      refNameDocEtaxList: [],
      refNameDocEtax: '',
      reason: '',
      dataProductList: [
        {
          product_name: '',
          quantity: '',
          price: '',
          net_price: ''
        }
      ],
      originalPrice: '',
      newPrice: '',
      differencePrice: '',
      Rules: {
        doc_number: [
          v => !!v || 'กรุณากรอกเลขที่เอกสาร',
          v => /^[^\s].*/.test(v) || /^\S.*/.test(v) || (v === '') || 'กรอกข้อมูลไม่ถูกต้อง'
        ],
        documentDateShow: [
          v => !!v || 'กรุณาเลือกวันที่เอกสาร'
        ],
        refNameDocEtax: [
          v => !!v || 'กรุณาเลือกเอกสารอ้างอิง'
        ],
        reason: [
          v => !!v || 'กรุณากรอกหมายเหตุ',
          v => /^[^\s].*/.test(v) || /^\S.*/.test(v) || (v === '') || 'กรอกข้อมูลไม่ถูกต้อง'
        ],
        product_name: [
          v => !!v || 'กรุณากรอกรายการสินค้าและบริการ',
          v => /^[^\s].*/.test(v) || /^\S.*/.test(v) || (v === '') || 'กรอกข้อมูลไม่ถูกต้อง'
        ],
        quantity: [
          v => !!v || 'กรุณากรอกจำนวน',
          v => (v !== '0.00' && v !== '0') || 'กรอกราคามากกว่า 0'
        ],
        price: [
          v => !!v || 'กรุณากรอกราคา',
          v => (v !== '0.00' && v !== '0') || 'กรอกราคามากกว่า 0'
        ],
        net_price: [
          v => !!v || 'กรุณากรอกราคารวม',
          v => (v !== '0.00' && v !== '0') || 'กรอกราคามากกว่า 0'
        ],
        originalPrice: [
          v => !!v || 'กรุณากรอกมูลค่าตามใบกำกับภาษีเดิม',
          v => (v !== '0.00' && v !== '0') || 'กรอกราคามากกว่า 0'
        ],
        newPrice: [
          v => !!v || 'กรุณากรอกมูลค่าที่ถูกต้อง',
          v => (v !== '0.00' && v !== '0') || 'กรอกราคามากกว่า 0'
        ],
        differencePrice: [
          v => !!v || 'กรุณากรอกผลต่าง',
          v => (v !== '0.00' && v !== '0') || 'กรอกราคามากกว่า 0'
        ]
      },
      lastIndexArr: 0
    }
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push('/Order/CreditNoteMobile').catch(() => {})
      } else {
        this.$router.push('/Order/CreditNote').catch(() => {})
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  created () {
    // this.$EventBus.$emit('changeNav')
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
      }
      if (localStorage.getItem('OnlinePurchase') !== null) {
        this.customerData = JSON.parse(Decode.decode(localStorage.getItem('OnlinePurchase')))
      }
      this.checkShop()
      // this.getListEtaxDocumentOrder()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    // this.$on('hook:beforeDestroy', () => {
    //   this.$EventBus.$off('getOrderList')
    // })
  },
  methods: {
    handleKeyDown (event) {
      const lines = this.reason.split('\n')
      if (event.key === 'Enter' && lines.length >= 3) {
        event.preventDefault()
      }
    },
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/OrderListMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/OrderList' }).catch(() => {})
      }
    },
    async getListEtaxDocumentOrder () {
      this.$store.commit('openLoader')
      this.refNameDocEtaxList = []
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id
      }
      await this.$store.dispatch('actionsListEtaxDocumentOrder', data)
      var response = await this.$store.state.ModuleSaleOrderEtax.stateListEtaxDocumentOrder
      if (response.message === 'Get all order E-TAX document success.') {
        this.$store.commit('closeLoader')
        this.refNameDocEtaxList = response.data.map(object => {
          return { ...object, ref_name_show: object.ref_name_doc_etax + ' ' + object.ref_doc_number }
        })
      } else {
        this.$store.commit('closeLoader')
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    checkShop () {
      if (this.userDetailSelling.is_gracz === 'yes') {
        this.shop = 'Gracz'
      } else {
        if (this.userDetailSelling.is_rattana === 'yes') {
          this.shop = 'Rattana'
        } else {
          this.shop = 'Sale Order'
        }
      }
    },
    addItem () {
      this.dataProductList.push(
        { product_name: '', quantity: '', price: '', net_price: '' }
      )
      this.lastIndexArr = this.dataProductList.length - 1
      console.log(this.dataProductList.length - 1)
    },
    deleteItem (index) {
      this.dataProductList.splice(index, 1)
      this.lastIndexArr = this.dataProductList.length - 1
    },
    saveDocumentDate (startDate) {
      var selectDateApi = new Date(startDate)
      selectDateApi = this.formatDateForApi(new Date(selectDateApi.setDate(selectDateApi.getDate()) - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10))
      this.DocumentDate = selectDateApi
      this.DocumentDateSave = selectDateApi
      this.DocumentDateShow = this.formatDateTimeTH(selectDateApi)
      this.modalDocumentDate = false
    },
    clearDocumentDate () {
      this.modalDocumentDate = false
      this.DocumentDate = this.DocumentDateSave
    },
    formatDateTimeTH (date) {
      var year = moment(date).locale('TH').add('Year', 543).format('YYYY')
      var dateTH = moment(date).locale('TH').format('D MMMM ' + year)
      return dateTH
    },
    formatDateForApi (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return (`${year}-${month}-${day}`)
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return (`${day}/${month}/${year}`)
    },
    closeConfirmCreateCreditNote () {
      if (this.MobileSize === false) {
        this.$router.push({ path: '/Order/OrderList' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/OrderListMobile' }).catch(() => {})
      }
    },
    async createCreditNote () {
      this.$store.commit('openLoader')
      var shopData = this.userDetailSelling
      if (this.$refs.FormCreditNote.validate(true)) {
        var productList = []
        this.dataProductList.forEach(element => {
          productList.push({
            price: element.price.replace(/,/g, ''),
            net_price: element.net_price.replace(/,/g, ''),
            quantity: element.quantity.replace(/,/g, ''),
            product_name: element.product_name
          })
        })
        var data = {
          seller_shop_id: shopData.seller_shop_id,
          doc_number: this.docNumber,
          date: this.DocumentDate,
          ref_order_number: this.refNameDocEtax.ref_order_number,
          ref_code_etax: this.refNameDocEtax.ref_code_etax,
          ref_doc_number: this.refNameDocEtax.ref_doc_number,
          reason: this.reason,
          product_list: productList,
          original_price: this.originalPrice.replace(/,/g, ''),
          new_price: this.newPrice.replace(/,/g, ''),
          difference_price: this.differencePrice.replace(/,/g, '')
        }
        await this.$store.dispatch('actionsCreateCreditNote', data)
        var response = await this.$store.state.ModuleSaleOrderEtax.stateCreateCreditNote
        if (response.message === 'Create credit note success.') {
          this.$store.commit('closeLoader')
          localStorage.setItem('createCreditNote', Encode.encode(response.data))
          if (this.MobileSize === false) {
            this.$router.push({ path: '/Order/OrderList' }).catch(() => {})
          } else {
            this.$router.push({ path: '/Order/OrderListMobile' }).catch(() => {})
          }
        } else {
          this.$store.commit('closeLoader')
          if (response.message === 'This user is unauthorized.') {
            this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
            window.location.assign('/')
          } else if (response.message === 'Not access this function.') {
            this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
            window.location.assign('/')
          } else {
            var [msg, iconMsg] = this.getErrorMsg(response.message)
            this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
          }
        }
      } else {
        this.$store.commit('closeLoader')
        this.$nextTick(() => {
          const el = document.getElementsByClassName('error--text')
          if (el) {
            document
              .getElementsByClassName('error--text')[0]
              .scrollIntoView({ behavior: 'smooth', block: 'end' })
          }
        })
      }
    },
    validate (e) {
      var t = e.value
      e.value = t.indexOf('.') >= 0 ? t.slice(0, t.indexOf('.') + 3) : t
    },
    changeQuantity (item) {
      if (item.quantity === 'NaN' || item.quantity === '') {
        item.quantity = ''
      } else {
        item.quantity = Number(parseFloat(item.quantity.replace(/,/g, '')).toFixed(2)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      }
      item.net_price = (item.quantity === '' ? 1.00 : parseFloat(item.quantity.replace(/,/g, '')).toFixed(2)) * (item.price === '' ? 1.00 : parseFloat(item.price.replace(/,/g, '')).toFixed(2))
      item.net_price = Number(item.net_price).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    changePrice (item) {
      if (item.price === 'NaN' || item.price === '') {
        item.price = ''
      } else {
        item.price = Number(parseFloat(item.price.replace(/,/g, '')).toFixed(2)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      }
      item.net_price = (item.quantity === '' ? 1.00 : parseFloat(item.quantity.replace(/,/g, '')).toFixed(2)) * (item.price === '' ? 1.00 : parseFloat(item.price.replace(/,/g, '')).toFixed(2))
      item.net_price = Number(item.net_price).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    changeNetPrice (item) {
      if (item.net_price === 'NaN' || item.net_price === '') {
        item.net_price = ''
      } else {
        item.net_price = Number(parseFloat(item.net_price.replace(/,/g, '')).toFixed(2)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      }
    },
    changeOriginalPrice () {
      if (this.originalPrice === 'NaN' || this.originalPrice === '') {
        this.originalPrice = ''
      } else {
        this.originalPrice = Number(parseFloat(this.originalPrice.replace(/,/g, '')).toFixed(2)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      }
    },
    changeTrueValue () {
      if (this.newPrice === 'NaN' || this.newPrice === '') {
        this.newPrice = ''
      } else {
        this.newPrice = Number(parseFloat(this.newPrice.replace(/,/g, '')).toFixed(2)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      }
    },
    changeDifference () {
      if (this.differencePrice === 'NaN' || this.differencePrice === '') {
        this.differencePrice = ''
      } else {
        this.differencePrice = Number(parseFloat(this.differencePrice.replace(/,/g, '')).toFixed(2)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      }
    },
    inputTwoDigit (item) {
      item = item.match(/^\d+\.?\d{0,2}/)
    },
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return ('กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning')
      } else if (msg === 'Data missing. Please check your parameter and try again.') {
        return ['ข้อมูลขาดหาย', 'warning']
      } else if (msg === 'Not access this function.') {
        return ['มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Employee not found. Please check and try again.') {
        return ['ไม่พบพนักงาน โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Seller shop not found.' || msg === 'Not Found Seller Shop') {
        return ['ไม่พบร้านค้า', 'warning']
      } else if (msg === 'Parameter Missing. Please check and try again.') {
        return ['ข้อมูลขาดหาย โปรดลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Employee not found.') {
        return ['ไม่พบพนักงาน', 'warning']
      } else if (msg === 'Customer in this shop not found.') {
        return ['ไม่พบลูกค้าในร้านนี้', 'warning']
      } else if (msg === "The order doesn't belong to this shop.") {
        return ['คำสั่งซื้อไม่ได้เป็นของร้านนี้', 'warning']
      } else if (msg === 'Failed to create E-tax. Please check and try again.') {
        return ['ไม่สามารถสร้าง E-tax ได้ โปรดตรวจสอบและลองอีกครั้ง', 'warning']
      } else if (msg === 'Access key is invalid') {
        return ['ไม่สามารถสร้าง E-tax ได้ Access key ไม่ถูกต้อง', 'warning']
      } else if (msg === 'Failed to create E-tax. Please setting E-tax credentials.') {
        return ['ไม่สามารถสร้างใบกำกับภาษีได้ เนื่องจากร้านค้ายังไม่ได้ยืนยัน E-Tax Credential', 'warning']
      } else if (msg === 'Failed to create credit note E-tax. Please check and try again.') {
        return ['ไม่สามารถสร้างใบลดหนี้ได้ โปรดตรวจสอบและลองอีกครั้ง', 'warning']
      } else if (msg === 'This ref_doc_number has already created a credit note.') {
        return ['เลขที่เอกสารอ้างอิงนี้ถูกสร้างใบลดหนี้แล้ว', 'warning']
      } else {
        return [msg, 'error']
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
<style>
  .v-text-field input {
    font-size: 0.9em;
  }
  .v-text-field__details {
    margin-bottom: 4px !important;
  }
  .input_text {
    height: 60px;
    opacity: 0.6;
  }
</style>
